import { TAccountRights } from '@app/services/account-rights-service/response-interfaces/account-rights';
import { defineActionGroup } from 'rd-redux-utils';

const accountRightsActionGroup = defineActionGroup('ACCOUNT RIGHTS');

export const setAccountRightsAction = accountRightsActionGroup.defineAction<{
  rights: TAccountRights;
}>('SET RIGHTS');
